import axios from "axios";
import endPoints from "../../../../config/endPoints";

export const searchFailedPaymentsApi = async(reqBody) => {
  return await axios.post(`${endPoints.searchFailedPayments}`, reqBody);
};

export const createReceiptForFailedPaymentApi = async(reqBody) => {
  return await axios.post(`${endPoints.createReceiptForFailedPayment}`, reqBody);
};
